import { render, staticRenderFns } from "./MhModal.vue?vue&type=template&id=38860d7e&"
import script from "./MhModal.vue?vue&type=script&lang=js&"
export * from "./MhModal.vue?vue&type=script&lang=js&"
import style0 from "./MhModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports